import { styled } from "@monolith-forensics/monolith-ui";
import { CheckSquare2Icon } from "lucide-react";

const StyledContainer = styled.div`
  display: flex;
  align-content: center;
  align-items: center;
  margin-left: 10px;
  cursor: pointer;
  color: ${(props) => props.theme.palette.text.secondary};
  &:hover {
    color: ${(props) => props.theme.palette.text.primary};
  }
`;

export const SelectedItemsBadge: React.FC<{ selected: number }> = ({
  selected,
}) => {
  return (
    <StyledContainer title="Selected Items">
      <CheckSquare2Icon
        size={14}
        style={{
          marginRight: 5,
        }}
      />
      <span>{selected || 0}</span>
    </StyledContainer>
  );
};
